import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { saveAs } from 'file-saver';

// Service
import { LimitFlowProposalService } from '../../../service/limit-flow-proposal/limit-flow-proposal.service';
import { CommonService } from '../../../../common/service/common.service';
import { DialogService } from "ng2-bootstrap-modal";
import { PatrimonyModalComponent } from "../../limit-flow-proposal/patrimony-modal/patrimony-modal.component";

@Component({
	moduleId: module.id,
	selector: 'guarantee',
	templateUrl: 'guarantee.component.html'
})
export class GuaranteeComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";
	@Input('proposalStatus') proposalStatus: string = "";
	@Input('profileUser') profileUser: string = "";
	@Input('currentTab') currentTab: string = "";
	@Input('isUserOwner') isUserOwner: boolean = false;

	guaranteeForm: FormGroup;
	private token;
	public guarantees: any[] = [];
	public tryCnpj: boolean = false;
	guaranteeIndex;

	public cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
	public cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];

	constructor(private fb: FormBuilder, private flashMessagesService: FlashMessagesService, private dialogService: DialogService, private limitFlowProposalService: LimitFlowProposalService, private commonService: CommonService) {

		this.guaranteeForm = fb.group({
			TipoGarantiaID: ['', Validators.compose([Validators.required])],
			Descricao: ['', Validators.compose([Validators.required])],
			GarantiaRecebida: '', // boolean
			Documento: '',
			Nome: '',
			Comentario: ''
		});

	}

	ngOnInit() {
		this.token = localStorage.getItem('yara.token');
		this.getGuarantee();
	}

	ruleGarantia() {
		if (this.limitFlowProposalService.blockProposalField(this.proposalStatus, this.isUserOwner) === 'disabled' || 
		(this.profileUser !== 'Assistente de Crédito' && this.profileUser !== 'Analista de Crédito Jr' && this.profileUser !== 'Analista de Crédito Pl' && this.profileUser !== 'Analista de Crédito Sr' && this.profileUser !== 'Supervisor de Crédito')) {
			if ((this.proposalStatus === 'WA' || this.proposalStatus === 'WG' || this.proposalStatus === 'AP' || this.proposalStatus === 'AF' || this.proposalStatus === 'FC') && 
			(this.profileUser === 'Assistente de Crédito' || this.profileUser === 'Analista de Crédito Jr' || this.profileUser === 'Analista de Crédito Pl' || this.profileUser === 'Analista de Crédito Sr' || this.profileUser === 'Supervisor de Crédito')) {
				return null;
			} else {
				return 'disabled';
			}
		} else {
			return null;
		}
	}

	applyCpfMask(i) {
		($(document).find(".doc-guarantee-cpf-" + i) as any).mask("000.000.000-00");
	}

	applyCnpjMask(i) {
		($(document).find(".doc-guarantee-cnpj-" + i) as any).mask("00.000.000/0000-00");
	}

	isCpf(i) {
		return this.limitFlowProposalService.guaranteesObj[i].Documento.replace(/[^\d]+/g, '').length === 11;
	}

	isCnpj(i) {
		return this.limitFlowProposalService.guaranteesObj[i].Documento.replace(/[^\d]+/g, '').length === 14;
	}

	openPatrimonyGuarantee(proposalGuarantee, i) {
		let disposable = this.dialogService.addDialog(PatrimonyModalComponent, {
			title: "Potencial Patrimônial",
			proposalGuaranteeDocument: proposalGuarantee.Documento.replace(/[^\d]+/g, ''),
			indice: i,
			proposalStatus: this.proposalStatus,
			comentarioFiador: this.limitFlowProposalService.guaranteesObj[i].Comentario,
			isUserOwner: this.isUserOwner
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
				var i = Number($("#tempPotencialPatrimonialIndiceGrupo").val());
				var potencialValue = $("#tempPotencialPatrimonialGrupo").val().toString();
				var comentario = $("#tempComentarioPatrimonialGrupo").val().toString();
				
				// Caso o fiador seja integrante do grupo, atualiza o patrimonio dele
				for (var j = 0; j < this.limitFlowProposalService.groupMembers.length; j++) {
					if (this.limitFlowProposalService.groupMembers[j].Documento === proposalGuarantee.Documento.replace(/[^\d]+/g, '')) {
						// Atualiza o integrante
						this.limitFlowProposalService.groupMembers[j].PotencialPatrimonial = Number(potencialValue);

						// Atualiza o obj que salva a alteração
						var exists = false;
						var integrantesDre = $("#integrantesDreDoc").val() ? JSON.parse($("#integrantesDreDoc").val().toString()) : [];
		
						if (integrantesDre[i]) {
							for (var key in integrantesDre) {
								var obj = integrantesDre[key];
								if (obj.Documento === this.limitFlowProposalService.groupMembers[j].Documento) {
									integrantesDre[i].PotencialPatrimonial = Number(potencialValue);
									exists = true;
								}
							}
						}
		
						if (!exists) {
							var data = {
								PropostaLCID: this.proposalID,
								PotencialPatrimonial: Number(potencialValue),
								Documento: this.limitFlowProposalService.groupMembers[j].Documento
							}
		
							integrantesDre.push(data);
						}
		
						$("#integrantesDreDoc").val(JSON.stringify(integrantesDre));

					}
				}		

				this.limitFlowProposalService.guaranteesObj[i].PotencialPatrimonial = Number(potencialValue);
				this.limitFlowProposalService.guaranteesObj[i].Comentario = comentario;
				$("#tempPotencialPatrimonialIndiceGrupo").val("");
				$("#tempPotencialPatrimonialGrupo").val("");
				$("#tempComentarioPatrimonialGrupo").val("");
			});
	}

	addProposalGuarantee(guarantee) {
		guarantee.TipoGarantia = guarantee.TipoGarantiaID;
		guarantee.TipoGarantiaID = guarantee.TipoGarantia.ID;
		this.limitFlowProposalService.guaranteesObj.push(guarantee);
		this.guaranteeForm.reset();
		this.flashMessagesService.show("Garantia adicionada", { cssClass: 'alert-success', timeout: 6000 });
	}

	removeProposalGuarantee(guarantee) {
		this.limitFlowProposalService.guaranteesObj = this.limitFlowProposalService.guaranteesObj.filter(item => item !== guarantee);
		this.flashMessagesService.show("Garantia removida", { cssClass: 'alert-success', timeout: 6000 });
	}

	getGuarantee() {
		if (this.guarantees.length === 0) {
			this.limitFlowProposalService.getGuarantee(this.token).subscribe(result => {
				if (result.Success) {
					this.guarantees = result.Result;
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);

			});
		}
	}

	mask(): any {
		return {
			mask: (value) => {
				value = value.replace(/[^\d]+/g, '');
				if (value.length < 12)
					return this.cpfMask;
				else
					return this.cnpjMask;
			}
		};
	}

	setGuaranteeDoc(e, i) {

		this.guaranteeIndex = i;
		this.limitFlowProposalService.guaranteesObj[i].Nome = "";
		
		if (e.target.value.replace(/[^\d]+/g, '').length === 11 || e.target.value.replace(/[^\d]+/g, '').length === 14) {
			this.limitFlowProposalService.getPatrimonusByDocument(e.target.value.replace(/[^\d]+/g, '')).subscribe(result => {
				if (result.Success) {

					// Preenche o registro da garantia
					this.limitFlowProposalService.guaranteesObj[this.guaranteeIndex].Nome = result.Result.Nome;
					this.limitFlowProposalService.guaranteesObj[this.guaranteeIndex].PotencialPatrimonial = result.Result.PotencialPatrimonial;
					this.limitFlowProposalService.guaranteesObj[this.guaranteeIndex].Documento = e.target.value.replace(/[^\d]+/g, '');

					// Preenche os patrimonios do fiador
					var bensRurais = result.Result.BemRural;
					var bensUrbanos = result.Result.BemUrbano;
					var bensMaquinas = result.Result.MaquinasEquipamentos;
					var precosPorRegiao = result.Result.PrecosPorRegiao;

					for (var keyRurais in bensRurais) {
						var exists = false;
						var obj = bensRurais[keyRurais];
						obj.PropostaLCID = this.limitFlowProposalService.proposalObj['ID'];
						obj.GarantiaID = null;
						obj.Documento = this.limitFlowProposalService.guaranteesObj[this.guaranteeIndex].Documento.replace(/[^\d]+/g, '');
						for (var keyRuraisObj in this.limitFlowProposalService.ruralsObj) {
							var objRurals = this.limitFlowProposalService.ruralsObj[keyRuraisObj];
							if (objRurals) {
								if (obj.Documento === objRurals.Documento && obj.IR === objRurals.IR) {
									exists = true;
								}
							}
						}
						if (!exists) {
							this.limitFlowProposalService.ruralsObj.push(obj);
						}
					}

					for (var keyUrbanos in bensUrbanos) {
						var exists = false;
						var obj = bensUrbanos[keyUrbanos];
						obj.PropostaLCID = this.limitFlowProposalService.proposalObj['ID'];
						obj.GarantiaID = null;
						obj.Documento = this.limitFlowProposalService.guaranteesObj[this.guaranteeIndex].Documento.replace(/[^\d]+/g, '');
						for (var keyUrbanosObj in this.limitFlowProposalService.urbansObj) {
							var objUrbans = this.limitFlowProposalService.urbansObj[keyUrbanosObj];
							if (objUrbans) {
								if (obj.Documento === objUrbans.Documento && obj.IR === objUrbans.IR) {
									exists = true;
								}
							}
						}
						if (!exists) {
							this.limitFlowProposalService.urbansObj.push(obj);
						}
					}

					for (var keyMaquinas in bensMaquinas) {
						var exists = false;
						var obj = bensMaquinas[keyMaquinas];
						obj.PropostaLCID = this.limitFlowProposalService.proposalObj['ID'];
						obj.GarantiaID = null;
						obj.Documento = this.limitFlowProposalService.guaranteesObj[this.guaranteeIndex].Documento.replace(/[^\d]+/g, '');
						for (var keyMaquinasObj in this.limitFlowProposalService.machinesObj) {
							var objMachines = this.limitFlowProposalService.machinesObj[keyMaquinasObj];
							if (objMachines) {
								if (obj.Documento === objMachines.Documento && obj.IR === objMachines.IR) {
									exists = true;
								}
							}
						}
						if (!exists) {
							this.limitFlowProposalService.machinesObj.push(obj);
						}
					}

					for (var keyPrecos in precosPorRegiao) {
						var exists = false;
						var obj = precosPorRegiao[keyPrecos];
						obj.PropostaLCID = this.limitFlowProposalService.proposalObj['ID'];
						obj.GarantiaID = null;
						obj.Documento = this.limitFlowProposalService.guaranteesObj[this.guaranteeIndex].Documento.replace(/[^\d]+/g, '');
						for (var keyPrecosObj in this.limitFlowProposalService.priceByRegionObj) {
							var objPrices = this.limitFlowProposalService.priceByRegionObj[keyPrecosObj];
							if (objPrices) {
								if (obj.Documento === objPrices.Documento && obj.Cidade.Nome === objPrices.Cidade.Nome) {
									exists = true;
								}
							}
						}
						if (!exists) {
							this.limitFlowProposalService.priceByRegionObj.push(obj);
						}
					}
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			});


		}
	}

	setGuaranteeComentario(e, i) {
		this.limitFlowProposalService.guaranteesObj[i].Descricao = e.target.value;
	}

	setGuaranteeNome(e, i) {
		this.limitFlowProposalService.guaranteesObj[i].Nome = e.target.value;
	}

	fileSelected(e, i) {
		console.log(e);
		var input: any = e.target;
		var file = input.files[0];
		this.uploadAttachment(file, i);
	}

	uploadAttachment(file, i) {
		var formData = new FormData();
		formData.append('Arquivo', file);
		formData.append('Tipo', 'PJ');
		this.limitFlowProposalService.insertFinancialDemos(formData).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Template enviado com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				this.limitFlowProposalService.guaranteesObj[i].PropostaLCDemonstrativoID = result.Result.ID;
				this.limitFlowProposalService.guaranteesObj[i].PotencialPatrimonial = result.Result.PotencialCredito;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	getDreFile(id) {
		this.limitFlowProposalService.getDreFile(id).subscribe(blob => {
			if (blob) {
				//Using File-saver.js
				saveAs(blob, 'dre' + "." + 'xls');
			} else {
				this.flashMessagesService.show("Problema ao baixar o arquivo", { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});

	}
}






// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/guarantee/guarantee.component.ts